// extracted by mini-css-extract-plugin
export default {"factor-base":"FatorCell_factor-base__5zDCT"};